/* istanbul ignore file */

export type ALEXA_CHANNEL_TYPE = "alexa";
export const ALEXA: ALEXA_CHANNEL_TYPE = "alexa";

export type AOG_CHANNEL_TYPE = "actions-on-google";
export const AOG: AOG_CHANNEL_TYPE = "actions-on-google";

export type DIALOGFLOW_CHANNEL_TYPE = "dialogflow";
export const DIALOGFLOW: DIALOGFLOW_CHANNEL_TYPE = "dialogflow";

export type LEX_CONNECT_TYPE = "lex-connect";
export const LEX_CONNECT: LEX_CONNECT_TYPE = "lex-connect";

export type LEX_V2_CHANNEL_TYPE = "lex-v2";
export const LEX_V2: LEX_V2_CHANNEL_TYPE = "lex-v2";

export type CHAT_WIDGET_TYPE = "chat-widget";
export const CHAT_WIDGET: CHAT_WIDGET_TYPE = "chat-widget";

export type INTELLIGENT_SEARCH_TYPE = "intelligent-search";
export const INTELLIGENT_SEARCH: INTELLIGENT_SEARCH_TYPE = "intelligent-search";

export type GOOGLE_BUSINESS_MESSAGES_TYPE = "google-business-messages";
export const GOOGLE_BUSINESS_MESSAGES: GOOGLE_BUSINESS_MESSAGES_TYPE = "google-business-messages";

export type FORM_WIDGET_TYPE = "form-widget";
export const FORM_WIDGET: FORM_WIDGET_TYPE = "form-widget";


// These are _typename values from the GraphQL schema
export type ChannelTypeName =
    "ActionsOnGoogleAppChannel" |
    "AlexaAppChannel" |
    "DialogflowAppChannel" |
    "ChatWidgetChannel" |
    "IntelligentSearchChannel" |
    "GoogleBusinessMessagesAppChannel" |
    "FormWidgetChannel";

export type SMBChannelTypes = CHAT_WIDGET_TYPE | INTELLIGENT_SEARCH_TYPE | FORM_WIDGET_TYPE | GOOGLE_BUSINESS_MESSAGES_TYPE

// These are types that are defined in the JSON
export type ChannelTypes =
    ALEXA_CHANNEL_TYPE |
    AOG_CHANNEL_TYPE |
    DIALOGFLOW_CHANNEL_TYPE |
    LEX_CONNECT_TYPE |
    LEX_V2_CHANNEL_TYPE |
    CHAT_WIDGET_TYPE |
    INTELLIGENT_SEARCH_TYPE |
    GOOGLE_BUSINESS_MESSAGES_TYPE |
    FORM_WIDGET_TYPE;